import { useLocale } from '../i18n/LocaleProvider'
import { Cpu, Globe, DeviceMobile, Hammer, PiggyBank } from '@phosphor-icons/react'
import type { Icon } from '@phosphor-icons/react'
import './WhyBybeitySection.css'

const differentiators: { icon: Icon; title: string; body: string; color: string }[] = [
  {
    icon: Cpu,
    color: '#007AFF',
    title: 'SaaS & AI Specialization',
    body: 'The only Japan entry service purpose-built for SaaS and AI startups. We speak your product language and your market.',
  },
  {
    icon: Globe,
    color: '#AF52DE',
    title: 'Native English + Japanese',
    body: 'Bilingual execution across every touchpoint — not just translation. We write your emails, your LP, your pitch decks in both languages.',
  },
  {
    icon: DeviceMobile,
    color: '#FF2D55',
    title: 'Gen Z Digital Fluency',
    body: 'Social media algorithms, video content, inbound marketing — we grew up here. Your Japanese SNS presence is in native hands.',
  },
  {
    icon: Hammer,
    color: '#FF9500',
    title: 'Execution-Focused, Not Advisory',
    body: 'We build your LP, post your SNS, run your sales outreach. No reports-only retainers. We deliver work product, not slides.',
  },
  {
    icon: PiggyBank,
    color: '#34C759',
    title: 'Fraction of the Cost',
    body: 'Comparable freelance engagements total ¥1–2M ($7K–$13K USD). Our all-in Starter Pack: $10,000. One invoice, one point of contact.',
  },
]

export default function WhyBybeitySection() {
  const { t } = useLocale()
  return (
    <section className="whybybeit-section" style={{ background: 'var(--home-bg)' }}>
      <div className="container">
        <div className="section-header">
          <span className="section-jp">{t("Why Bybeit")}</span>
          <h2>{t('A different kind of market entry partner')}</h2>
          <p>{t("We built this service because no one else was doing it right for SaaS companies.")}</p>
        </div>

        <div className="wb-grid">
          {differentiators.map((d, i) => (
            <div className={`wb-card${i === 0 ? ' wb-card--featured' : ''}`} key={d.title}>
              <div
                className="wb-card-inner"
                style={{ background: `linear-gradient(135deg, ${d.color}18 0%, transparent 55%)` }}
              >
                <d.icon size={28} weight="bold" color="#000" />
                <h3>{t(d.title)}</h3>
                <p>{t(d.body)}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
